module.exports = __webpack_public_path__ + "js/0.71cb8b96.worker.js"